import React, { useState } from "react";
import { AppStrings, AppStringsByLang } from "../terms/appTerms";
import { Box, Button, Checkbox, Divider, FormControl, FormControlLabel, FormGroup, FormLabel, IconButton, Link, List, ListItem, ListItemIcon, ListItemText, MenuItem, Radio, RadioGroup, Select, TextField, Typography } from "@mui/material";
import { CalculationResult, DegreeType, Faculty, Lang, MiluimPeriod, RightType } from "../types/general";
import moment from "moment";
import { DatePicker } from "@mui/x-date-pickers";
import { Cancel, Check, CheckCircle, Clear, Delete, DeleteOutline } from "@mui/icons-material";
import { calcRights, getFaculty } from "../utils/appUtils";


function CalcResult(props: { result: CalculationResult[], lang: Lang }) {
    const Strings = AppStringsByLang(props.lang);
    const faculty = getFaculty();
    const getresultTitle = (res: CalculationResult) => {
        switch (res.type) {
            case RightType.Course:
                return Strings.course;
            case RightType.NekudotZehut:
                return Strings.NekudotZehut;
            case RightType.AvneyPina:
                return Strings.AvneyPina;
            case RightType.ExamDoesntCount:
                return Strings.examDoesntCount;
            case RightType.HighestGrade:
                return Strings.getHighestGrade;
            case RightType.TestTimeExtension:
                return Strings.testTimeExtension;
            case RightType.NoAttendanceRequired:
                return Strings.noAttendanceRequired;
            case RightType.IntermediateAssignmentsPtor:
                return Strings.intermediateAssignmentsPtor;
            case RightType.PtorMandatoryAttendance:
                return Strings.ptorMandatoryAttendance;
            case RightType.AlternativeAssessment:
                return Strings.alternativeAssessment;
            case RightType.DentalRight:
                return res.dentalRightTitle;
        }
    }
    return (
        <Box>
            <Divider />
            <Typography variant="h5" fontWeight="bold" align="center" mt="32px">סך הזכאות לפטור מנקודות זכות ועובר בינארי</Typography>
            {props.result.length > 0 && <List sx={{ paddingX: "16px" }}>
                {props.result.filter((res) => res.isFinalSum).map((res) => <ListItem >
                    {res.isGreater &&
                        <ListItemIcon>
                            <CheckCircle color="success" />
                        </ListItemIcon>}
                    {res.isGreater !== true &&
                        <ListItemIcon>
                            <Check color="success" />
                        </ListItemIcon>}
                    <ListItemText primary={<Typography style={res.isGreater ? { fontWeight: 'bold' } : { fontWeight: 'normal' }}>
                        {getresultTitle(res)}
                        {res.sum > 0 && <Typography fontWeight={700} display="inline" mx="8px">{res.sum}
                            {res.sum == 10 && res.type === RightType.NekudotZehut ? '*' : ''}
                        </Typography>}
                    </Typography>}
                        secondary={<Typography color="GrayText">
                            {res.reason[props.lang]}</Typography>} />
                </ListItem>)}
            </List>}
            {props.result.length === 0 && <Typography align="center" my="16px">
                {Strings.noRights}
            </Typography>}
            <Divider />
            
            <Typography variant="h5" fontWeight="bold" align="center" mt="32px">זכויות נוספות ופירוט - תשפ"ה</Typography>
            {props.result.length > 0 && <List sx={{ paddingX: "16px" }}>
                {props.result.filter((res) => !res.isFinalSum && res.is24_25).map((res) => <ListItem >
                    {res.isGreater &&
                        <ListItemIcon>
                            <CheckCircle color="success" />
                        </ListItemIcon>}
                    {res.isGreater !== true &&
                        <ListItemIcon>
                            <Check color="success" />
                        </ListItemIcon>}
                    <ListItemText primary={<Typography style={res.isGreater ? { fontWeight: 'bold' } : { fontWeight: 'normal' }}>
                        {getresultTitle(res)}
                        {res.sum > 0 && <Typography fontWeight={700} display="inline" mx="8px">{res.sum}
                            {res.sum == 10 && res.type === RightType.NekudotZehut ? '*' : ''}
                        </Typography>}
                    </Typography>}
                        secondary={<Typography color="GrayText">
                            {res.reason[props.lang]}</Typography>} />
                </ListItem>)}
            </List>}
            {props.result.filter((res) => !res.isFinalSum && res.is24_25).length === 0 && <Typography align="center" my="16px">
                {Strings.noRights}
            </Typography>}
            <Divider />

            {props.result.filter((res) => !res.isFinalSum && !res.is24_25).length > 0 && (
                <Typography variant="h5" fontWeight="bold" align="center" mt="32px">
                    מתווה תשפ"ד
                </Typography>
            )}
            {props.result.length > 0 && <List sx={{ paddingX: "16px" }}>
                {props.result.filter((res) => !res.isFinalSum && !res.is24_25).map((res) => <ListItem >
                    {res.isGreater &&
                        <ListItemIcon>
                            <CheckCircle color="success" />
                        </ListItemIcon>}
                    {res.isGreater !== true &&
                        <ListItemIcon>
                            <Check color="success" />
                        </ListItemIcon>}
                    <ListItemText primary={<Typography style={res.isGreater ? { fontWeight: 'bold' } : { fontWeight: 'normal' }}>
                        {res.isMalag ? 'לפי המל"ג- ' : 'לפי האוניברסיטה- '}{getresultTitle(res)}
                        {res.sum > 0 && <Typography fontWeight={700} display="inline" mx="8px">{res.sum}
                            {res.sum == 10 && res.type === RightType.NekudotZehut ? '*' : ''}
                        </Typography>}
                    </Typography>}
                        secondary={<Typography color="GrayText">
                            {res.reason[props.lang]}</Typography>} />
                </ListItem>)}
            </List>}
            
            {props.result.find(res => res.sum == 10) ? <Typography mt="16px" align="center" color="secondary" variant="body2">{Strings.hachraga10nekodotZcootComment}</Typography> : ''}
            <Typography mt="16px" mx="24px" align="center" color="secondary" variant="body2">
                {Strings.inCaseOfContradiction}
                <Link href="https://new.huji.ac.il/news/%D7%94%D7%A7%D7%9C%D7%95%D7%AA-%D7%95%D7%94%D7%AA%D7%90%D7%9E%D7%95%D7%AA-%D7%90%D7%A7%D7%93%D7%9E%D7%99%D7%95%D7%AA"
                    target="_blank" rel="noopener">
                    {Strings.rules}
                </Link>
                {Strings.rulesLinkIsImportant}
            </Typography>
            {/* CSE */}
            {faculty === Faculty.CSE && <Typography mt="16px" mx="24px" align="center" color="secondary" variant="body2">
                {Strings.inCaseOfMistake}
                <Link href="mailto: meitalb@savion.huji.ac.il" target="_blank" rel="noopener"> meitalb@savion.huji.ac.il</Link>.
            </Typography>}
            {faculty === Faculty.CSE && <Typography mb="16px" mt="16px" mx="24px" align="center" color="secondary" variant="body2">
                {Strings.anyOtherIssue}
                <Link href="https://miluim.cs.huji.ac.il/he/counseling" target="_blank" rel="noopener">{Strings.consultant}.</Link>
            </Typography>}
            {/* HUM */}
            {faculty === Faculty.HUM && <Typography mt="16px" mx="24px" align="center" color="secondary" variant="body2">
                {Strings.askForPersonal1}
                <Link href="https://forms2.ekmd.huji.ac.il/home/student%20manager/Pages/FRM_STM01.aspx?isdlg=1&e=1" target="_blank" rel="noopener"> {Strings.askForPersonal2}</Link>
                {Strings.askForPersonal3}
            </Typography>}
            {faculty === Faculty.HUM && <Typography mb="16px" mt="16px" mx="24px" align="center" color="secondary" variant="body2">
                {Strings.forAnyQuestion}
                <Link href="mailto: humstudents@savion.huji.ac.il" target="_blank" rel="noopener">{Strings.miluimConsultant}</Link>
                {Strings.ofHUM}
            </Typography>}
            {/* General */}
            {faculty === Faculty.General && <Typography mt="16px" mx="24px" align="center" color="secondary" variant="body2">
                {Strings.inCaseOfCalcMistake}
                <Link href="mailto: calc@cs.huji.ac.il" target="_blank" rel="noopener">calc@cs.huji.ac.il</Link>.
            </Typography>}
            {faculty === Faculty.General && <Typography mb="16px" mt="16px" mx="24px" align="center" color="secondary" variant="body2">
                {Strings.anyOtherIssue}
                <Link href="https://studean.huji.ac.il/%D7%A8%D7%A9%D7%99%D7%9E%D7%AA-%D7%A8%D7%9B%D7%96%D7%99-%D7%9E%D7%99%D7%9C%D7%95%D7%90%D7%99%D7%9D" target="_blank" rel="noopener">{Strings.consultant}.</Link>
            </Typography>}
        </Box>
    );
}
export default CalcResult;
